import initCookieNotification from './vue/initCookieNotification.js';
import initModal from './vue/initModal.js';
import LazyLoading from './components/lazyloading.js';
import QuoteVideoBlock from './components/quote-video-block';
import LogisticsMapLocations from './components/logistics-map-locations';
import OdometerAnimation from './components/odometer-animation';
import ContactLinks from './components/contact-links';

initCookieNotification();
initModal.init();
LazyLoading.init();
QuoteVideoBlock.init();
LogisticsMapLocations.init();
OdometerAnimation.init();
ContactLinks.init();
